/**
 * Valores iniciais do formulário de Acquirer (Adquirente / Maquininha).
 * 
 * Contempla:
 * - Taxas por bandeira (mapa dinâmico — visa, mastercard, elo, pix etc.)
 * - Configuração de antecipação de recebíveis
 * - Conta bancária padrão de depósito
 * 
 * NOTA: O campo `rates` é um mapa dinâmico onde cada chave é o ID da bandeira
 * e o valor contém { credit: [{installments, rate}], debit, pix }.
 * Isso é gerenciado pela tela de Adquirentes com seleção multi-bandeira.
 */
export const acquirerDefaults = {
    name: "",
    status: "active",

    // Taxas por bandeira — mapa dinâmico
    // Exemplo: { visa: { credit: [{installments: 1, rate: 2.5}], debit: 1.5, pix: 0.99 } }
    rates: {},

    // Configuração de Antecipação de Recebíveis
    anticipation: {
        enabled: false,           // Liga/desliga antecipação automática
        type: "automatic",        // "automatic" (tudo antecipa) ou "manual" (por venda)
        feePerMonth: 0,           // Taxa de antecipação POR MÊS antecipado (ex: 1.99%)
        settlementDays: 1,        // D+N — prazo para o dinheiro cair na conta (1 = D+1)
    },

    // Conta bancária padrão onde a adquirente deposita
    idBankAccount: "",
    bankAccountName: "",
};
